export const MILLISECONDS_BY_TIME_UNIT: { [key: string]: number } = {
  MONTH: 2629800000,
  m: 2629800000,
  WEEK: 604800000,
  w: 604800000,
};

export const MONTHS_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const MONTH_HISTORIC_OPTIONS = [
  {
    label: "April-2024",
    month: "3",
    year: "2024",
  },
  {
    label: "May-2024",
    month: "4",
    year: "2024",
    disabled: false,
  },
  {
    label: "June-2024",
    month: "5",
    year: "2024",
    disabled: true,
  },
  {
    label: "July-2024",
    month: "6",
    year: "2024",
    disabled: true,
  },
];
